import { Star } from "lucide-react";
import { Overline } from "@/components/Reveal";

// Static Google Reviews placeholder. Paste a live widget/embed into the
// marked slot below (e.g. Elfsight, or Google Places API) when ready.
export default function GoogleReviews() {
  return (
    <div data-testid="google-reviews" className="bg-white border border-black/10 p-8 md:p-10">
      <Overline className="mb-6">Google Reviews</Overline>
      <div className="flex items-center gap-4 mb-2">
        <div className="flex items-center gap-1 text-sand">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-5 w-5 fill-sand text-sand" />
          ))}
        </div>
        <span className="font-display text-3xl font-extrabold">5.0</span>
      </div>
      <p className="text-sm text-taupe font-light mb-6">Based on verified Google reviews from Perth homeowners, designers and builders.</p>

      <a
        href="https://www.google.com/search?q=CEMTEX+Perth+reviews"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="google-reviews-link"
        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-charcoal border-b border-sand pb-1 hover:text-sand transition-colors"
      >
        Read our Google reviews
      </a>
    </div>
  );
}
